// /**
//  * SwatchSync
//  * ----------
//  * Jab bhi kisi product card (grid ya slider ke andar) me color swatch
//  * click/select hota hai, us card ke apne quick-add form ka hidden
//  * <input name="id"> update ho jata hai — taake "Add to cart" sahi
//  * variant submit kare, na ke default/pehla variant.
//  *
//  * Event DELEGATION use kiya hai (document par ek hi listener):
//  *  - Har card independently kaam karta hai (closest() se apna scope dhoondta hai)
//  *  - Agar slider slides duplicate/clone karta hai (infinite loop sliders me aam hai),
//  *    tab bhi kaam karega — kyunke hum har baar dynamically closest card dhoondte hain,
//  *    kisi fixed id/getElementById par depend nahi karte.
//  *
//  * Kahan lagana hai:
//  *  - Is file ko assets me daal ke theme.liquid me </body> se pehle
//  *    <script src="{{ 'swatch-sync.js' | asset_url }}" defer></script> se load karo.
//  */

// document.addEventListener('DOMContentLoaded', function () {
//   console.log('[SwatchSync] init: delegated change-listener attach ho gaya document par');

//   document.addEventListener('change', function (e) {
//     const input = e.target;

//     // sirf color swatch radios par react karo, baqi sab input change ignore
//     if (!input.matches('.swatch-input__input')) return;

//     console.log('[SwatchSync] ---- swatch change detected ----');
//     console.log('[SwatchSync] raw input element:', input);

//     // is specific swatch ka parent product-card dhoondo (chahe grid ho ya slider slide)
//     const card = input.closest('.card-wrapper.product-card-wrapper');
//     if (!card) {
//       console.warn('[SwatchSync] SKIP: is swatch ke liye parent .product-card-wrapper nahi mila', input);
//       return;
//     }

//     // isi card ke andar wala hidden id input + product link nikalo (dusre cards ko touch nahi karte)
//     const hiddenIdInput = card.querySelector('input.product-variant-id');
//     const productLink   = card.querySelector('.js-card-product-link');

//     const variantId  = input.dataset.variantId;   // e.g. "51138421031240"
//     const productUrl = input.dataset.productUrl;  // e.g. "/products/gion-laptop-case-13-..."
//     const colorName  = input.value;                // e.g. "dark olive"

//     console.log('[SwatchSync] color selected:', colorName);
//     console.log('[SwatchSync] variantId from data-variant-id:', variantId);

//     if (!hiddenIdInput) {
//       console.error('[SwatchSync] ERROR: is card me input.product-variant-id (form ka hidden id field) nahi mila', card);
//       return;
//     }

//     if (!variantId) {
//       console.error('[SwatchSync] ERROR: clicked swatch input par data-variant-id attribute missing hai', input);
//       return;
//     }

//     const oldValue = hiddenIdInput.value;
//     hiddenIdInput.value = variantId;

//     console.log('[SwatchSync] FORM UPDATED -> id field:', oldValue, '=>', hiddenIdInput.value);

//     // optional but useful: product link ka href bhi naye variant ke hisaab se update kar do
//     if (productLink && productUrl) {
//       const newHref = productUrl + '?variant=' + variantId;
//       productLink.setAttribute('href', newHref);
//       console.log('[SwatchSync] product link href updated ->', newHref);
//     } else {
//       console.log('[SwatchSync] (info) product link href update skip - productLink ya productUrl available nahi');
//     }

//     console.log('[SwatchSync] ---- done ----');
//   });
// });


document.addEventListener('DOMContentLoaded', function () {
  const cardRequestTokens = new WeakMap();

  document.addEventListener('click', function (e) {
    const label = e.target.closest('.js-card-swatch');
    if (!label) return;

    e.preventDefault();

    const card = label.closest('.card-wrapper.product-card-wrapper');
    if (!card) return;

    const loadingTarget = label.closest('.js-card-product') || card;

    const swatchGroup = label.closest('.product-form__input--swatch');
    const localInput = label.previousElementSibling;

    if (swatchGroup) {
      const localInputs = swatchGroup.querySelectorAll('.swatch-input__input');

      localInputs.forEach(function (inp) {
        inp.checked = false;
      });
    }

    if (localInput && localInput.matches('.swatch-input__input')) {
      localInput.checked = true;
      localInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const hiddenIdInput = card.querySelector('input.product-variant-id');
    const productLinks = card.querySelectorAll('.js-card-product-link');

    const variantId = label.dataset.variantId;
    const productUrl = label.dataset.productUrl;

    if (!hiddenIdInput) return;
    if (!variantId || !productUrl) return;

    hiddenIdInput.value = variantId;

    if (productLinks.length) {
      const newHref = productUrl + '?variant=' + variantId;

      productLinks.forEach(function (link) {
        link.setAttribute('href', newHref);
      });
    }

    const cardImage = loadingTarget.querySelector('.media');
    if (!cardImage) return;

    const myToken = Symbol('swatch-click');
    cardRequestTokens.set(card, myToken);

    loadingTarget.classList.add('-loading');

    fetch(productUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        if (cardRequestTokens.get(card) !== myToken) {
          return;
        }

        const variantContent = new DOMParser().parseFromString(html, 'text/html');
        const variantImage = variantContent.querySelector('.card-image');

        if (variantImage) {
          cardImage.innerHTML = variantImage.innerHTML;
        }

        loadingTarget.classList.remove('-loading');
      })
      .catch(function () {
        loadingTarget.classList.remove('-loading');
      });
  });
});